import { WaterThermometerIcon } from './WaterThermometerIcon';

/**
 * author: Michael Irigoyen
 * id 276FDABE-30C6-406C-BAED-FF6BFC10B6BA
 * name water-thermometer
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/water-thermometer.svg
 * tags
 * - Weather 
 * - Home Automation 
 */
export const BoilPointIcon = WaterThermometerIcon;
export default BoilPointIcon